const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-slate-50 to-gray-100 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            Trusted Referral Partners
          </h1>
          <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
            A network of vetted professionals supporting your compliance and security needs.
          </p>
        </div>
      </div>
      
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-teal-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-gray-500/5 rounded-full blur-3xl"></div>
    </section>
  );
};

export default HeroSection;
